import { render, staticRenderFns } from "./TypeGoals.vue?vue&type=template&id=538a7e3f&scoped=true"
import script from "./TypeGoals.vue?vue&type=script&lang=js"
export * from "./TypeGoals.vue?vue&type=script&lang=js"
import style0 from "./TypeGoals.vue?vue&type=style&index=0&id=538a7e3f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538a7e3f",
  null
  
)

export default component.exports